import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const TopOffendersAggSubRegionReportRequest = (values, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}RanReportKpis/GenerateTopOffendersAggSubRegionReport`,
	data: { values, userId }
});
